export const getSpecialPaths = {
  "/attn-signup": [],
}

export default getSpecialPaths
